const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

export const FRONTEND_IMG_URL = isLocalhost
  ? "http://localhost:3000/"
  : "https://dev.medbudd.com/";

export const BACKEND_API_URL = isLocalhost
  ? "http://localhost:5000/api/"
  : "https://medbudds.vercel.app/api/";
